import React from "react";
import { Checkbox } from "@headlessui/react";
import classNames from "classnames";
import styles from "./fix-checkbox.module.scss";
import { Icon } from "@/elements-react/fix-icon";

export interface FixCheckboxProps {
  name: string;
  indeterminate?: boolean;
  checked?: boolean;
  onChange?: (e: { value: boolean; name: string }) => void;
  children?: React.ReactNode;
}

export function FixCheckbox(props: FixCheckboxProps) {
  const { name, indeterminate = false, checked = false, onChange, children } = props;

  const handleChange = (value: boolean) => {
    onChange?.({ value, name });
  };

  return (
    <div className={styles.root}>
      <Checkbox checked={checked} indeterminate={indeterminate} onChange={handleChange} name={name} className={styles.checkbox}>
        <div className={styles.base}>
          <span
            className={classNames(styles.control, {
              [styles.checked]: checked,
              [styles.indeterminate]: indeterminate,
            })}
          >
            {checked && !indeterminate && (
              <span className={styles.tick}>
                <Icon name="check" />
              </span>
            )}
            {indeterminate && <span className={styles.dash}>–</span>}
          </span>
          <span className={styles.label}>{children}</span>
        </div>
      </Checkbox>
    </div>
  );
}

export default FixCheckbox;
